module.exports = __webpack_public_path__ + "static/pay-by-link-preview-atelier-f2ad8142590b2d61c97a2184d90aec02.png";